//#region src/version.ts
const version = "5.0.0-beta.4";

//#endregion
export { version };
//# sourceMappingURL=version.js.map